// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .input-group:has(> .form-control.is-invalid) .input-group-prepend > .input-group-text {\n  border: 1px solid red;\n}\n", ""]);
// Exports
module.exports = exports;
